import React, { useMemo, useCallback } from 'react';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useTransactions } from './useTransactions';

import style from '../SportsbookGamingHistory.scss';

export const useTableData = () => {
    const transactions = useTransactions();
    const translate = useComponentTranslations();

    const getAccordionCell = useCallback((name, value) => (
        <>
            <div className={`${style.highlight} accordionBodyCellName`}>{translate(name)}</div>
            <div className="accordionBodyCellValue">{value}</div>
        </>
    ), [translate]);

    const getAccordionRowList = useCallback((list) =>
        list.filter(item => item.value)
            .map(({ id, key, value }) => ({ id, content: getAccordionCell(key, value) })), [getAccordionCell]);

    return useMemo(() =>
        ({
            accordionView: {
                rows: transactions.map(item => {
                    const {
                        name,
                        amount,
                        date,
                        code,
                        endBalance,
                        clientPlatform
                    } = item;

                    return {
                        id: code,
                        headerCells: [
                            {
                                id: 0,
                                content: name,
                                className: `${style.highlight} accordionHeaderSmallDetails`
                            },
                            {
                                id: 1,
                                content: (
                                    <>
                                        <span className={style.amount}>{amount}</span>
                                        <span className={style.date}>{date}</span>
                                    </>
                                ),
                                className: `${style.smallDetails} accordionHeaderSmallDetails`
                            }
                        ],
                        rowCells: getAccordionRowList([
                            { id: 0, key: 'transaction.code', value: code },
                            { id: 1, key: 'transaction.endBalance', value: endBalance },
                            { id: 2, key: 'transaction.clientPlatform', value: clientPlatform }
                        ])
                    };
                })
            }
        })
    , [transactions, getAccordionRowList]);
};
